import type {PhoneMask} from '@logistics-frontend/core/formatters'
import type {PhoneRule} from '@logistics-frontend/core/phones/types'

import type {fetchAddressSuggest} from '../api'
import type {LaunchResponse} from '../api/cargo-corp'
import type {UtmParameters} from '../api/cargo-crm'
import type {MakeUrlApi} from './make-url-api'

type Point = [number, number]

export const enum DeviceType {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export const enum DeviceOS {
  MacOs = 'MacOS',
  IOs = 'iOS',
  Android = 'Android',
}

export const enum DeviceVendor {
  Apple = 'Apple',
  Huawei = 'Huawei',
}

export const enum Brand {
  Yango = 'yango',
  Yandex = 'yandex',
}

export const enum Dir {
  Ltr = 'ltr',
  Rtl = 'rtl',
}

export const enum CarBodyType {
  Van = 'van',
  LCV_M = 'lcv_m',
  LCV_L = 'lcv_l',
  LCV_XL = 'lcv_xl',
  LCV_XXL = 'truck_5t',
}

export const enum AvailableTariff {
  EXPRESS = 'express',
  CARGO = 'cargo',
  NDD_SELF_PICKUP = 'ndd_self_pickup',
  NDD_SHIPMENT = 'ndd_shipment',
}

export type InitialProps = {
  availableTariffs: AvailableTariff[]
  zonePoint: Point
  zoneName?: string
  from?: Point
  tariff?: string
  to?: Point
}

export type RoutesConfig = {
  home: string
}

type Experiments = {
  delivery_frontend_order_business_toggle_visibility?: {
    enabled?: boolean
  }
  delivery_frontend_order_promo_banner?: {
    enabled?: boolean
  }
}

export type AddressSuggestResponsePromise = ReturnType<typeof fetchAddressSuggest>

export type AddressSuggestResponse = Awaited<AddressSuggestResponsePromise>

export type ServerConfig = {
  /**
   * Геолокация пользователя (точка)
   */
  location: Point
  device: DeviceType
  deviceOS: DeviceOS
  deviceVendor: DeviceVendor
  trustHost: string
  experiments3?: Experiments
  accountUrl: string
  registrationUrl: string
  routes: RoutesConfig
  version: string
  branding: Brand
  dir: Dir
  i18n: Record<string, unknown>
  basename: string
  yaAuthProxyHost: string
  passportHost: string
  avatarsHost: string
  passportApiHost: string
  passportAppID?: string
  yandexuid: string
  lang: string
  countryCode: string
  currency: string
  metrikaID?: number
  gtmLink?: string
  launch?: LaunchResponse
  utm?: UtmParameters
  phoneMask?: PhoneMask
  mapLang: string
  rules?: PhoneRule[]
  localReplacements?: Record<string, string>
  currencySign: string
  origin: string
  initialProps: InitialProps
  host: string
  tld?: string
}

type Params = Record<string, string>
type ParamsOrPath = Params | string

export type ClientConfig = {
  getAccountUrl(paramsOrPath?: ParamsOrPath, params?: Params): string
  getRegistrationUrl(params?: Record<string, string>): string
  getPhoneMask(phone?: string): string
  normalizePhone(phone?: string): string
  getPassportUrl(path: string): string
  checkIsValidPhone: (phone?: string) => boolean
}

export type AppConfig = ServerConfig & ClientConfig

export type {MakeUrlApi}

export * from './form'
export * from './outer'
